import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function bannerListings() {
    const banner = document.querySelector('.banner--case-studies');

    if (!banner) return;

    const tl = gsap.timeline();
    tl.to('.text-line-1', { opacity: 1, duration: 0.25 });
    tl.to('#draw-mask-1', { duration: 0.5, drawSVG: '100% 100%' });
    tl.to('.text-line-2', { opacity: 1, duration: 0.5 });
    tl.to('#draw-mask-2', { duration: 0.5, drawSVG: '100% 100%' });
    tl.to('.text-line-3', { opacity: 1, duration: 0.5 });
}
